import useSWR from 'swr';

import { ICard } from '@/redux/modules/creditCards';
import { getCoreApi } from '@/utility/getCoreApi';

import apiRequest from './apiRequest';

const getCardsData = async (userId?: number) => {
  return apiRequest<ICard[]>(
    {
      url: `${getCoreApi()}/users/${userId}/cards`,
      params: { user_id: userId },
      method: 'GET',
    },
    true,
  );
};

export const useCardsData = (userId?: number) => {
  const { data, error, mutate, isValidating } = useSWR(userId ? [userId] : null, () =>
    getCardsData(userId),
  );

  const isLoading = !data && !error && isValidating;

  return {
    data: data,
    isError: error,
    mutate,
    isValidating,
    isLoading,
  };
};
